export default "__VITE_ASSET__B87oMHNi__"